var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.495 12.405l8.86 8.86c.777.777.774 2.04-.008 2.822a1.995 1.995 0 01-2.821.008l-8.86-8.86-9.192 9.19a1.995 1.995 0 01-2.821-.008 1.995 1.995 0 01-.008-2.821l9.19-9.191-9-9A1.995 1.995 0 01.843.582 1.995 1.995 0 013.665.575l9 9 8.67-8.67a1.995 1.995 0 012.822.008c.781.782.785 2.045.008 2.822l-8.67 8.67z"
  })));
}

export default SvgCommonIconClose;